"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withNTLDProvider = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var launchdarkly_react_client_sdk_1 = require("launchdarkly-react-client-sdk");
var useLDConfig_1 = (0, tslib_1.__importDefault)(require("./hooks/useLDConfig"));
var withNTLDProvider = function (Component) {
    var NTLDWrapper = function (props) {
        var lDClientConfig = (0, useLDConfig_1.default)();
        var ComponentWithLDProvider = (0, react_1.useMemo)(function () {
            return (0, launchdarkly_react_client_sdk_1.withLDProvider)(lDClientConfig)(function () { return (react_1.default.createElement(Component, (0, tslib_1.__assign)({}, props, { lDClientConfig: lDClientConfig }))); });
        }, [lDClientConfig, props]);
        return react_1.default.createElement(ComponentWithLDProvider, null);
    };
    return (0, react_1.memo)(NTLDWrapper);
};
exports.withNTLDProvider = withNTLDProvider;
